import React, { useEffect, useState } from "react";
import Navbar from "../navbar/Navbar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TextField,
  Box,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";

import { apiCall } from "../../../service";
import ModalDiv from "./Modal";
import config from "../../config";
import { urlHelper } from "../../utils/urlHelpers";
import { Line, Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  BarElement,
  ArcElement,
} from "chart.js";
import ChartDetail from "./ChartDetail";
import VerticalLine from "./VerticalLine";
import { set } from "date-fns";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  BarElement,
  ArcElement
);

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const Jobs = () => {
  const [allVehicleData, setAllVehicleData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const [paths, setPaths] = useState([]);
  const [stops, setStops] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [rowsCount, setRowsCount] = useState(0);
  const [date, setDate] = useState(new Date());
  const [selectedJobCount, setSelectedJobCount] = useState(0);
  const [fatchStatus, setFatchStatus] = useState(null);
  const [performancePieChartData, setPerformancePieChartData] = useState({
    labels: [], // ["Upcoming", "Live", "Completed"],
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ["#2b9ea6", "#8b912c", "#186321"],
        hoverOffset: 1,
      },
    ],
    value: 300,
  });

  const [jobDelayData, setJobDelayData] = useState({
    labels: [], // ["Early", "Late", "OnTime"],
    datasets: [
      {
        data: [20, 54, 19],
        backgroundColor: ["#05a826", "#f86530", "#3252e3"],
        hoverOffset: 1,
      },
    ],
    value: 300,
  })
  const rowsPerPage = 15;

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const fetchData = async (status) => {
    setLoading(true);
    try {
      const endPoint = urlHelper(config.apiEndpoints.jobList.url, {
        page: page + 1,
        ...(date.startDate && { from: date.startDate }),
        ...(date.endDate && { to: date.endDate }),
        ...(status && { status: status }),
      });
      const payload = {
        host: config.apiEndpoints.jobList.host,
        endPoint: endPoint,
        method: "GET",
      };
      const response = await apiCall(payload);

      const allVehicleData = response.data.rows.map((data) => ({
        id: data.id,
        jobsDesc: data.Job_Desc,
        vehicleNo: data.Vehicle_no,
        status:
          data.Status === 1
            ? "Upcoming"
            : data.Status === 2
            ? "Live"
            : data.Status === 3
            ? "Complete"
            : data.Status === 4
            ? "Cancel"
            : "NA",
        jobStart: data.Job_Start.replace("T", " ").split(".")[0],
        createdAt: data.createdAt.replace("T", " ").split(".")[0],
        updatedAt: data.updatedAt.replace("T", " ").split(".")[0],
      }));
      setRowsCount(response.data.rows.length);
      setAllVehicleData(allVehicleData);
      setTotalCount(response.data.count);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  const fetchJobCountData = async (status) => {
    setLoading(true);
    try {
      const endPoint = urlHelper(config.apiEndpoints.jobsCountData.url, {
        ...(date.startDate && { from: date.startDate }),
        ...(date.endDate && { to: date.endDate }),
        ...(status && { status: status }),
      });
      const payload = {
        host: config.apiEndpoints.jobsCountData.host,
        endPoint: endPoint,
        method: "GET",
      };
      const response = await apiCall(payload);
      // console.log("response", response.data.count);
      if (response.data?.jobStatus) {
        const jobRunningStatus = response.data.jobStatus;
        const jobDelayStatus = response.data.jobDelayStatus;
  // ------------- Running Job data-----------------------------
        const upcoming =jobRunningStatus.upcoming
        const live = jobRunningStatus.live
        const completed = jobRunningStatus.completed
  //--------------- Job Delay data-----------------------------
        const early = jobDelayStatus.early
        const late = jobDelayStatus.late
        const onTime = jobDelayStatus.onTime
        console.log("upcoming", upcoming);
        setSelectedJobCount(upcoming + live + completed);
        setPerformancePieChartData({
          labels: [], // ["Upcoming", "Live", "Completed"],
          datasets: [
            {
              data: [upcoming, live, completed],
              backgroundColor: performancePieChartData.datasets[0].backgroundColor,//["#78a4eb", "#878a62", "#658f67"],
              hoverOffset: 1,
            },
          ],
          value: 300,
        });
        setJobDelayData({
          labels: [], // ["Early", "Late", "OnTime"],
          datasets: [
            {
              data: [early, late, onTime],
              backgroundColor: jobDelayData.datasets[0].backgroundColor,//["#05a826", "#d61c15", "#3252e3"],
              hoverOffset: 1,
            },
          ],
          value: 300,
        })
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (date.startDate && date.endDate) {
      fetchJobCountData(fatchStatus);
    }
  }, [date,fatchStatus]);
  console.log("rows count", rowsCount);
  useEffect(() => {
    if (date.startDate && date.endDate) {
      fetchData(fatchStatus);
    }
  }, [page, date,fatchStatus]);

  useEffect(() => {
    setPage(0);
  }, [searchQuery, selectedDate]);

  const filteredVehicles = allVehicleData.filter(
    (vehicle) =>
      vehicle.vehicleNo.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (selectedDate === "" || vehicle.jobStart.startsWith(selectedDate))
  );

  const displayedVehicles =
    searchQuery || selectedDate ? filteredVehicles : allVehicleData;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDateChange = ({ startDate, endDate }) => {
    // setSelectedDate(event.target.value);
    setDate({
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    });
    console.log("Selected date:", startDate.toISOString().split("T")[0]);
  };

  const handleOpenModal = async (id, desc, vehicleNo) => {
    setSelectedJob({ id, desc, vehicleNo });
    setModalLoading(true);
    await Promise.all([getStopsData(id), getPathsData(id)]);
    setModalLoading(false);
    setOpenModal(true);
  };

  const getPathsData = async (jobId) => {
    try {
      if (jobId != null) {
        const payload = {
          body: {
            jobId: jobId,
          },
          method: "POST",
          host: config.apiEndpoints.geFullPath.host,
          endPoint: config.apiEndpoints.geFullPath.url,
        };
        const data = await apiCall(payload);
        const latLngArray = data.map((location) => ({
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng),
        }));
        setPaths(latLngArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getStopsData = async (jobId) => {
    try {
      if (jobId != null) {
        const payload = {
          body: {
            jobid: jobId,
          },
          method: "POST",
          host: config.apiEndpoints.jobsDetail.host,
          endPoint: config.apiEndpoints.jobsDetail.url,
        };
        const data = await apiCall(payload);
        const addressData = data.data.rows.map((row) => row.AddressBook);
        const latLngArray = addressData.map((location) => ({
          lat: parseFloat(location.latitude),
          lng: parseFloat(location.longitude),
          id: location.code,
          name: location.name,
        }));
        setStops(latLngArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const formatDate = (isoDateString) => {
    const dateUTC = new Date(isoDateString);
    const utcTime = dateUTC.getTime();
    const dateIST = new Date(utcTime);
    dateIST.setHours(dateIST.getHours() + 5);
    dateIST.setMinutes(dateIST.getMinutes() + 30);
    return dateIST.toLocaleString("en-IN", {
      hour: "numeric",
      minute: "numeric",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour12: true,
    });
  };

  const totalPages = Math.ceil(totalCount / rowsPerPage);

  return (
    <div className="bg-gray-100 px-4">
      <Navbar
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        placeholder="Search vehicle..."
        showFilter={showFilter}
        showCalendar={true}
        selectedDates={handleDateChange}
      />
      {loading ? (
        <div className="loader-wrapper">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="py-6">
            <div
              className="w-full flex item-center flex-col lg:flex-row gap-10"
              // container
              // spacing={1}
              // columns={{ xs: 3, sm: 8, md: 12 }}
              // className="p-3 w-full flex "
            >
              {/* Job Status */}
              <Grid
                container
                size={4}
                className="flex items-center w-full bg-white rounded-lg"
              >
                <Grid className="p-1" onClick={()=>{setFatchStatus(null)}}>
                  <Box className="font-semibold text-sm text-center">
                    Job Status
                  </Box>
                  <Box className="w-48">
                    <ChartDetail
                      performancePieChartData={performancePieChartData}
                      count={selectedJobCount}
                    />
                  </Box>
                </Grid>
                <Grid
                  container
                  rowSpacing={2}
                  spacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  className="p-3 ml-4 w-80 "
                >
                  {/* Live Job data Line */}
                  <Grid size={6} onClick={()=>{setFatchStatus(2)}}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            performancePieChartData.datasets[0]
                              .backgroundColor[1]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Running
                        </Box>
                        <Box className="font-bold ">
                          {performancePieChartData.datasets[0].data[1]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Completed Job data Line */}
                  <Grid size={6} onClick={()=>{setFatchStatus(3)}}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            performancePieChartData.datasets[0]
                              .backgroundColor[2]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Completed
                        </Box>
                        <Box className="font-bold ">
                          {performancePieChartData.datasets[0].data[2]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Upcoming Job data Line */}
                  <Grid size={6} onClick={()=>{setFatchStatus(1)}}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            performancePieChartData.datasets[0]
                              .backgroundColor[0]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Upcoming
                        </Box>
                        <Box className="font-bold ">
                          {performancePieChartData.datasets[0].data[0]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* Job Delay */}
              <Grid
                container
                size={4}
                className="flex items-center w-full bg-white rounded-lg"
              >
                <Grid className="p-1">
                  <Box className="font-semibold text-sm text-center">
                    Job Delay Status
                  </Box>
                  <Box className="w-48">
                    <ChartDetail
                      performancePieChartData={jobDelayData}
                      count={selectedJobCount}
                    />
                  </Box>
                </Grid>
                <Grid
                  container
                  rowSpacing={2}
                  spacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  className="p-3 ml-4 w-80 "
                >
                  {/* Live Job data Line */}
                  <Grid size={6}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            jobDelayData.datasets[0]
                              .backgroundColor[0]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Early
                        </Box>
                        <Box className="font-bold ">
                          {jobDelayData.datasets[0].data[0]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Completed Job data Line */}
                  <Grid size={6}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            jobDelayData.datasets[0]
                              .backgroundColor[1]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Late
                        </Box>
                        <Box className="font-bold ">
                          {jobDelayData.datasets[0].data[1]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Upcoming Job data Line */}
                  <Grid size={6}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            jobDelayData.datasets[0]
                              .backgroundColor[2]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Ontime
                        </Box>
                        <Box className="font-bold ">
                          {jobDelayData.datasets[0].data[2]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* Hop point status */}
              <Grid
                container
                size={4}
                className="flex items-center w-full bg-white rounded-lg"
              >
                <Grid className="p-1">
                  <Box className="font-semibold text-sm text-center">
                    Hop Status  (Underdevelopment)
                  </Box>
                  <Box className="w-48">
                    <ChartDetail
                      performancePieChartData={jobDelayData}
                      count={selectedJobCount}
                    />
                  </Box>
                </Grid>
                <Grid
                  container
                  rowSpacing={2}
                  spacing={2}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  className="p-3 ml-4 w-80 "
                >
                  {/* Live Job data Line */}
                  <Grid size={6}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            performancePieChartData.datasets[0]
                              .backgroundColor[1]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Running
                        </Box>
                        <Box className="font-bold ">
                          {performancePieChartData.datasets[0].data[1]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Completed Job data Line */}
                  <Grid size={6}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            performancePieChartData.datasets[0]
                              .backgroundColor[2]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Completed
                        </Box>
                        <Box className="font-bold ">
                          {performancePieChartData.datasets[0].data[2]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Upcoming Job data Line */}
                  <Grid size={6}>
                    <Grid container>
                      <Box>
                        <VerticalLine
                          thickness={6}
                          height={45}
                          color={
                            performancePieChartData.datasets[0]
                              .backgroundColor[0]
                          }
                        />
                      </Box>
                      <Grid className="pl-3">
                        <Box className="text-sm text-gray-700 font-medium">
                          Upcoming
                        </Box>
                        <Box className="font-bold ">
                          {performancePieChartData.datasets[0].data[0]}
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>

            {/* <TextField
                                label="Job Start"
                                type="date"
                                value={selectedDate}
                                onChange={handleDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            /> */}
          </div>
          <div className="w-full bg-gray-100">
          <TableContainer className="" component={Paper}>
            <Table className="">
              <TableHead>
                <TableRow
                  sx={{
                    "& th": {
                      fontWeight: "bold",
                      fontSize: "15px",
                    },
                  }}
                >
                  <TableCell>SL#</TableCell>
                  <TableCell>JOB DESCRIPTION</TableCell>
                  <TableCell>VEHICLE NUMBER</TableCell>
                  <TableCell>JOB START</TableCell>
                  <TableCell>STATUS</TableCell>
                  <TableCell>CREATED AT</TableCell>
                  <TableCell>UPDATED AT</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedVehicles.map((job) => (
                  <TableRow
                    key={job.id}
                    onClick={() => {
                      handleOpenModal(job.id, job.jobsDesc, job.vehicleNo);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>{job.id}</TableCell>
                    <TableCell>{job.jobsDesc}</TableCell>
                    <TableCell>{job.vehicleNo}</TableCell>
                    <TableCell>{formatDate(job.jobStart)}</TableCell>
                    <TableCell>{job.status}</TableCell>
                    <TableCell>{formatDate(job.createdAt)}</TableCell>
                    <TableCell>{formatDate(job.updatedAt)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={rowsCount < 15 ? page * 15 + rowsCount : totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[]}
              labelRowsPerPage="Rows per page"
              disabled={totalPages === 0}
              nextButtonProps={{ disabled: rowsCount < 15 }}
              backButtonProps={{ disabled: page <= 0 }}
            />
          </TableContainer>
          </div>
        </>
      )}
      {modalLoading ? (
        <div className="loading_modal">
          <div className="loader-wrapper">
            <div className="truck-wrapper">
              <div className="truck">
                <div className="truck-container"></div>
                <div className="glases"></div>
                <div className="bonet"></div>
                <div className="base"></div>
                <div className="base-aux"></div>
                <div className="wheel-back"></div>
                <div className="wheel-front"></div>
                <div className="smoke"></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ModalDiv
          open={openModal}
          paths={paths}
          stops={stops}
          handleClose={handleCloseModal}
          jobId={selectedJob?.id}
          jobDescription={selectedJob?.desc}
          vehicleNo={selectedJob?.vehicleNo}
        />
      )}
    </div>
  );
};

export default Jobs;
